import { defineMessages } from 'react-intl';

export default defineMessages({
	serviceDeskFilter: {
		defaultMessage: 'Service desk',
		description: 'Label for the service desk filter option in the search results picker',
		id: 'sd.all.articles.result.servicedesk.filter.name',
	},
	portal: {
		defaultMessage: 'Portal',
		description: 'Label for the portal filter option in the search results picker',
		id: 'cv.search.servicedesk-filter.portal',
	},
});
